import { InteractionType } from "@azure/msal-browser";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import {
  MsalProvider,
  UnauthenticatedTemplate,
  MsalAuthenticationTemplate,
} from "@azure/msal-react";
import ProtectedRoutes from "./Generic/ProtectedRoutes";
import Authenticating from "./Generic/Authenticating";
import Metrics from "./app/Metrics.js";
import Home from "./app/Home.js";
import Header from "./components/generic/Header.js";
import Footer from "./components/generic/Footer.js";
import Operations from "./app/Operations.js";
import { EnvProvider } from "./context/EnvContext.js";
import Registration from "./app/Registration.js";

function App({ msalInstance }) {
  return (
    <EnvProvider>
      <BrowserRouter>
        <MsalProvider instance={msalInstance}>
          <MsalAuthenticationTemplate
            interactionType={InteractionType.Redirect}
          >
            <Header />
            <div
              style={{
                height: "calc(90px)",
                width: "100%",
              }}
            ></div>
            <Routes>
              <Route path="/self-registration" element={<Registration />} />
              <Route
                path="/"
                element={
                  <ProtectedRoutes
                    role="LLMaaS_Admin"
                    msalInstance={msalInstance}
                  >
                    <Home />
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/milford-aidc"
                element={
                  <ProtectedRoutes
                    role="LLMaaS_Admin"
                    msalInstance={msalInstance}
                  >
                    <Operations />
                  </ProtectedRoutes>
                }
              />
              <Route
                path="/warren-aidc"
                element={
                  <ProtectedRoutes
                    role="LLMaaS_Admin"
                    msalInstance={msalInstance}
                  >
                    <Operations />
                  </ProtectedRoutes>
                }
              />
              {/* Unified Metrics route */}
              <Route
                path="/metrics"
                element={
                  <ProtectedRoutes
                    role="LLMaaS_Admin"
                    msalInstance={msalInstance}
                  >
                    <Metrics />
                  </ProtectedRoutes>
                }
              />
              {/* Backward-compatible redirects */}
              <Route path="/tgi-metrics" element={<Navigate to="/metrics" replace />} />
              <Route path="/gateway-metrics" element={<Navigate to="/metrics" replace />} />
              {/* Catch-all route that still enforces admin rights */}
              <Route
                path="*"
                element={
                  <ProtectedRoutes msalInstance={msalInstance}>
                    <Navigate to="/" replace />
                  </ProtectedRoutes>
                }
              />
            </Routes>
          </MsalAuthenticationTemplate>
          <UnauthenticatedTemplate>
            <Authenticating />
          </UnauthenticatedTemplate>
          <Footer />
          <Toaster
            position="bottom-right"
            reverseOrder={false}
            toastOptions={{
              style: {
                marginBottom: "25px",
              },
            }}
          />
        </MsalProvider>
      </BrowserRouter>
    </EnvProvider>
  );
}

export default App;
